import { Download, Moon, RefreshCw, Send } from 'lucide-react';
import { useAnimationLoop, useTypewriter } from './useOnboardingAnim';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const HANDOVER_PHASES = [1000, 1000, 1000, 1000, 1200];

const SBAR_LINES = [
  'Situation: Post-op day 2, stable.',
  'Assessment: Pain controlled, vitals WNL.',
  'Recommendation: Continue current plan.',
];

export default function HandoverDemoAnimation() {
  const phase = useAnimationLoop(HANDOVER_PHASES);

  const line1 = useTypewriter(SBAR_LINES[0], phase >= 1, 24);
  const line2 = useTypewriter(SBAR_LINES[1], phase >= 2, 24);
  const line3 = useTypewriter(SBAR_LINES[2], phase >= 3, 24);
  const showOutstanding = phase >= 2;
  const highlightSubmit = phase >= 4;
  const highlightPdf = phase === 3;

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className="flex h-full w-full flex-col justify-center space-y-1.5 px-1">
      <div className="flex items-center justify-between rounded-lg bg-handover px-3 py-2 text-white">
        <div>
          <p className="text-[10px] font-bold">Shift Handover</p>
          <p className="text-[8px] opacity-90">Night shift · 4 patients</p>
        </div>
        <Moon className="h-5 w-5 opacity-80" />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-2 shadow-sm">
        <p className="text-[9px] font-semibold">Layla Yousef · Room 3</p>
        <div className="mt-1 min-h-[36px] space-y-0.5">
          {line1 && <p className="text-[8px] text-gray-600">{line1}</p>}
          {line2 && <p className="text-[8px] text-gray-600">{line2}</p>}
          {line3 && <p className="text-[8px] text-gray-600">{line3}</p>}
          {phase < 1 && (
            <>
              <div className="h-1 w-full rounded bg-gray-200" />
              <div className="h-1 w-4/5 rounded bg-gray-200" />
            </>
          )}
        </div>
        <p
          className={`mt-1.5 text-[8px] text-gray-500 transition-all duration-400 ${
            showOutstanding ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'
          }`}
        >
          Outstanding: Reassess pain in 2h
        </p>
      </div>

      <div className="flex gap-2">
        <button
          type="button"
          className={`flex flex-1 items-center justify-center gap-1 rounded-lg border py-1.5 text-[8px] font-semibold transition-all duration-300 ${
            highlightPdf ? 'scale-105 border-primary bg-primary-light text-primary' : 'border-gray-200 text-gray-600'
          }`}
        >
          <Download className="h-3 w-3" />
          PDF
        </button>
        <button
          type="button"
          className={`flex flex-1 items-center justify-center gap-1 rounded-lg py-1.5 text-[8px] font-semibold text-white transition-all duration-300 ${
            highlightSubmit ? 'scale-105 bg-handover shadow-md' : 'bg-handover'
          }`}
        >
          <Send className="h-3 w-3" />
          Submit
        </button>
      </div>

      <div className="flex items-center justify-center gap-1 text-[8px] text-gray-500">
        <RefreshCw className={`h-3 w-3 ${phase === 0 ? 'animate-spin' : ''}`} />
        Or record a voice handover per patient
      </div>
      </div>
    </div>
  );
}
